var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _vm._l(_vm.addRoutes, function (item) {
        return [
          item.id == _vm.activeId
            ? _c(
                "div",
                {
                  staticStyle: {
                    color: "#fff",
                    display: "flex",
                    padding: "0px 0px 0px 19px",
                    height: "50px",
                    "align-items": "center",
                    "font-size": "15px",
                  },
                },
                [
                  item.meta && item.meta.icon && item.meta.icon !== "#"
                    ? _c("svg-icon", {
                        staticStyle: { height: "20px", width: "20px" },
                        attrs: { "icon-class": item.meta.icon },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isCollapse,
                          expression: "!isCollapse",
                        },
                      ],
                      staticStyle: {
                        "margin-left": "5px",
                        display: "inline-block",
                        "white-space": "pre",
                        width: "calc(100% - 25px)",
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "unique-opened": false,
                "active-text-color": _vm.variables.menuActiveText,
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            _vm._l(_vm.routes, function (route) {
              return _c("sidebar-item", {
                key: route.path || route.id || "menu-" + _vm.index,
                attrs: { item: route, "base-path": route.path },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }